export const SEND_TEXT = 'GIFTYA/SEND_TEXT';
export const SEND_TEXT_RESET = 'GIFTYA/SEND_TEXT_RESET';
export const SEND_CONFIRMATION_CODE = 'GIFTYA/SEND_CONFIRMATION_CODE';
export const SEND_CONFIRMATION_CODE_RESET = 'GIFTYA/SEND_CONFIRMATION_CODE_RESET';
export const LOGIN_STEP_1_CONFIRMATION_CODE = 'GIFTYA/LOGIN_STEP_1_CONFIRMATION_CODE';
export const LOGIN_STEP_1_CONFIRMATION_CODE_RESET = 'GIFTYA/LOGIN_STEP_1_CONFIRMATION_CODE_RESET';
export const LOGIN = 'GIFTYA/LOGIN';
export const LOGIN_RESET = 'GIFTYA/LOGIN_RESET';
export const GET_TOKEN = 'GIFTYA/GET_TOKEN';
export const GET_TOKEN_RESET = 'GIFTYA/GET_TOKEN_RESET';
export const GET_IDP_AUTHENTICATION_URL = 'GIFTYA/GET_IDP_AUTHENTICATION_URL';
export const GET_IDP_AUTHENTICATION_URL_RESET = 'GIFTYA/GET_IDP_AUTHENTICATION_URL_RESET';
export const IDP_LOGIN = 'GIFTYA/IDP_LOGIN';
export const IDP_LOGIN_RESET = 'GIFTYA/IDP_LOGIN_RESET';
export const CONFIRM_SOCIAL_LOGIN_ACCOUNT_ACCOUNT_EXISTS = 'GIFTYA/CONFIRM_SOCIAL_LOGIN_ACCOUNT_ACCOUNT_EXISTS ';
export const CONFIRM_SOCIAL_LOGIN_ACCOUNT_ACCOUNT_EXISTS_RESET = 'GIFTYA/CONFIRM_SOCIAL_LOGIN_ACCOUNT_ACCOUNT_EXISTS _RESET';
export const CONFIRM_LOGIN = 'GIFTYA/CONFIRM_LOGIN';
export const CONFIRM_LOGIN_RESET = 'GIFTYA/CONFIRM_LOGIN_RESET';
export const CONFIRM_SOCIAL_LOGIN_ACCOUNT = 'GIFTYA/CONFIRM_SOCIAL_LOGIN_ACCOUNT';
export const CONFIRM_SOCIAL_LOGIN_ACCOUNT_RESET = 'GIFTYA/CONFIRM_SOCIAL_LOGIN_ACCOUNT_RESET';
export const GET_CONFIRMATION_CODE_FOR_SOCIAL_LOGIN = 'GIFTYA/GET_CONFIRMATION_CODE_FOR_SOCIAL_LOGIN';
export const GET_CONFIRMATION_CODE_FOR_SOCIAL_LOGIN_RESET = 'GIFTYA/GET_CONFIRMATION_CODE_FOR_SOCIAL_LOGIN_RESET';
export const RESEND_CONFIRMATION_CODE_FOR_SOCIAL_LOGIN = 'GIFTYA/RESEND_CONFIRMATION_CODE_FOR_SOCIAL_LOGIN';
export const RESEND_CONFIRMATION_CODE_FOR_SOCIAL_LOGIN_RESET = 'GIFTYA/RESEND_CONFIRMATION_CODE_FOR_SOCIAL_LOGIN_RESET';
export const GET_CONFIRMATION_CODE_FOR_ACCOUNT_EXISTS_SOCIAL_LOGIN = 'GIFTYA/GET_CONFIRMATION_CODE_FOR_ACCOUNT_EXISTS_SOCIAL_LOGIN';
export const GET_CONFIRMATION_CODE_FOR_ACCOUNT_EXISTS_SOCIAL_LOGIN_RESET = 'GIFTYA/GET_CONFIRMATION_CODE_FOR_ACCOUNT_EXISTS_SOCIAL_LOGIN_RESET';
export const GET_USER_IDP_ACCOUNTS = 'GIFTYA/GET_USER_IDP_ACCOUNTS';
export const GET_USER_IDP_ACCOUNTS_RESET = 'GIFTYA/GET_USER_IDP_ACCOUNTS_RESET';
export const LINK_USER_IDP_ACCOUNT = 'GIFTYA/LINK_USER_IDP_ACCOUNT';
export const LINK_USER_IDP_ACCOUNT_RESET = 'GIFTYA/LINK_USER_IDP_ACCOUNT_RESET';
export const DELETE_USER_IDP_ACCOUNT = 'GIFTYA/DELETE_USER_IDP_ACCOUNT';
export const DELETE_USER_IDP_ACCOUNT_RESET = 'GIFTYA/DELETE_USER_IDP_ACCOUNT_RESET';






export const deleteUserIdpAccount = (payload, meta, error) => ({
    type: DELETE_USER_IDP_ACCOUNT,
    payload,
    meta,
    error
});
export const deleteUserIdpAccountReset = (payload, meta, error) => ({
    type: DELETE_USER_IDP_ACCOUNT_RESET,
    payload,
    meta,
    error
});
export const linkUserIdpAccount = (payload, meta, error) => ({
    type: LINK_USER_IDP_ACCOUNT,
    payload,
    meta,
    error
});
export const linkUserIdpAccountReset = (payload, meta, error) => ({
    type: LINK_USER_IDP_ACCOUNT_RESET,
    payload,
    meta,
    error
});
export const getUserIdpAccounts = (payload, meta, error) => ({
    type: GET_USER_IDP_ACCOUNTS,
    payload,
    meta,
    error
});
export const getUserIdpAccountsReset = (payload, meta, error) => ({
    type: GET_USER_IDP_ACCOUNTS_RESET,
    payload,
    meta,
    error
});
export const getConfirmationCodeForAccountExistsSocialLogin = (payload, meta, error) => ({
    type: GET_CONFIRMATION_CODE_FOR_ACCOUNT_EXISTS_SOCIAL_LOGIN,
    payload,
    meta,
    error
});
export const getConfirmationCodeForAccountExistsSocialLoginReset = (payload, meta, error) => ({
    type: GET_CONFIRMATION_CODE_FOR_ACCOUNT_EXISTS_SOCIAL_LOGIN_RESET,
    payload,
    meta,
    error
});
export const getConfirmationCodeForSocialLogin = (payload, meta, error) => ({
    type: GET_CONFIRMATION_CODE_FOR_SOCIAL_LOGIN,
    payload,
    meta,
    error
});
export const getConfirmationCodeForSocialLoginReset = (payload, meta, error) => ({
    type: GET_CONFIRMATION_CODE_FOR_SOCIAL_LOGIN_RESET,
    payload,
    meta,
    error
});
export const resendConfirmationCodeForSocialLogin = (payload, meta, error) => ({
    type: RESEND_CONFIRMATION_CODE_FOR_SOCIAL_LOGIN,
    payload,
    meta,
    error
});
export const resendConfirmationCodeForSocialLoginReset = (payload, meta, error) => ({
    type: RESEND_CONFIRMATION_CODE_FOR_SOCIAL_LOGIN_RESET,
    payload,
    meta,
    error
});
export const confirmSocialLoginAccountAccountExists = (payload, meta, error) => ({
    type: CONFIRM_SOCIAL_LOGIN_ACCOUNT_ACCOUNT_EXISTS,
    payload,
    meta,
    error
});
export const confirmSocialLoginAccountAccountExistsReset = (payload, meta, error) => ({
    type: CONFIRM_SOCIAL_LOGIN_ACCOUNT_ACCOUNT_EXISTS_RESET,
    payload,
    meta,
    error
});
export const confirmLogin = (payload, meta, error) => ({
    type: CONFIRM_LOGIN,
    payload,
    meta,
    error
});
export const confirmLoginReset = (payload, meta, error) => ({
    type: CONFIRM_LOGIN_RESET,
    payload,
    meta,
    error
});
export const confirmSocialLoginAccount = (payload, meta, error) => ({
    type: CONFIRM_SOCIAL_LOGIN_ACCOUNT,
    payload,
    meta,
    error
});
export const confirmSocialLoginAccountReset = (payload, meta, error) => ({
    type: CONFIRM_SOCIAL_LOGIN_ACCOUNT_RESET,
    payload,
    meta,
    error
});
export const idpLogin = (payload, meta, error) => ({
    type: IDP_LOGIN,
    payload,
    meta,
    error
});
export const idpLoginReset = (payload, meta, error) => ({
    type: IDP_LOGIN_RESET,
    payload,
    meta,
    error
});
export const getIdpAuthenticationUrl = (payload, meta, error) => ({
    type: GET_IDP_AUTHENTICATION_URL,
    payload,
    meta,
    error
});
export const getIdpAuthenticationUrlReset = (payload, meta, error) => ({
    type: GET_IDP_AUTHENTICATION_URL_RESET,
    payload,
    meta,
    error
});
export const sendText = (payload, meta, error) => ({
    type: SEND_TEXT,
    payload,
    meta,
    error
});
export const sendTextReset = (payload, meta, error) => ({
    type: SEND_TEXT_RESET,
    payload,
    meta,
    error
});
export const sendConfirmationCode = (payload, meta, error) => ({
    type: SEND_CONFIRMATION_CODE,
    payload,
    meta,
    error
});
export const sendConfirmationCodeReset = (payload, meta, error) => ({
    type: SEND_CONFIRMATION_CODE_RESET,
    payload,
    meta,
    error
});
export const loginStep1ConfirmationCode = (payload, meta, error) => ({
    type: LOGIN_STEP_1_CONFIRMATION_CODE,
    payload,
    meta,
    error
});
export const loginStep1ConfirmationCodeReset = (payload, meta, error) => ({
    type: LOGIN_STEP_1_CONFIRMATION_CODE_RESET,
    payload,
    meta,
    error
});
export const login = (payload, meta, error) => ({
    type: LOGIN,
    payload,
    meta,
    error
});
export const loginReset = (payload, meta, error) => ({
    type: LOGIN_RESET,
    payload,
    meta,
    error
});
export const getToken = (payload, meta, error) => ({
    type: GET_TOKEN,
    payload,
    meta,
    error
});
export const getTokenReset = (payload, meta, error) => ({
    type: GET_TOKEN_RESET,
    payload,
    meta,
    error
});
